import React, { useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Col } from "reactstrap";
import ReactTooltip from "react-tooltip";
import classNames from "classnames";
import moment from "moment";

import { useGetAlerts, useGetDevices } from "service/AgrismartService";
import { useSettings } from "service/SettingsService";

import { Row } from "components/Layout";
import Image from "components/Image";
import AdversitiesIntervalBar from "components/IntervalBar/AdversitiesIntervalBar";
import AdversitySusceptibilityModal from "components/Modal/AdversitySusceptibilityModal";
import Timeline from "containers/Data/Timeline";

import { crops as CROPS } from "../../constants";
import { infoIcon, infoIcon_over, settingsIcon, settingsIcon_over, menuIcons } from 'img/icons'
import { roles } from "../../constants";
import styles from "./_agrismart.module.scss"


function AdversityItem({ adversity, settingsBtnAction }) {
	const user = useSelector(store => store.users.data)

	return (
		<Col
			md={4} sm={4}
			className={classNames(styles.adversityItem)}
		>
			<label>{adversity.label}</label>
			<picture>
				<img src={adversity.picture} alt={adversity.label} />
			</picture>
			<Row className={classNames(styles.adversityButtonRow)}>
				<Link to={`/guide/${adversity.name}`} data-tip="Descrizione avversità">
					<Image
						src={infoIcon}
						hover={infoIcon_over}
					/>
				</Link>
				{settingsBtnAction && roles.isAdmin(user) &&
					<div data-tip="Impostazioni avversità">
						<Image
							src={settingsIcon}
							hover={settingsIcon_over}
							onClick={settingsBtnAction}
						/>
					</div>
				}
				{adversity.chartPage &&
					<Link to={adversity.chartPage} data-tip="Grafico avversità">
						<Image
							src={menuIcons.chart}
							hover={menuIcons.chart_over}
						/>
					</Link>
				}
				<ReactTooltip effect='solid' place='bottom' />
			</Row>
		</Col>
	)
}

export default function AdversitiesPage() {
	let { crop } = useParams()
	let { devices } = useGetDevices()
	let { alerts } = useGetAlerts()
	let navigate = useNavigate()
	let { saveSettings, resetSettings, deleteSetting, getSettingValue, changeSetting, changeMultipleSettings } = useSettings()

	const [device, setDevice] = useState();
	const [interval, setInterval] = useState('monthly');
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	const [adversitySusceptibilityModalOpen, setAdversitySusceptibilityModalOpen] = useState(null)
	const adversities = CROPS.adversities[crop]

	function changeDevice(id) {
		let device = devices.find(d => d.id === parseInt(id))
		setDevice(device)
	}

	let filteredAlerts = alerts.filter(a => {
		let start, end
		if (interval === 'monthly') {
			start = moment().subtract(1, 'months')
			end = moment()
		}
		else if (interval === 'yearly') {
			start = moment().subtract(1, 'years')
			end = moment()
		}
		else { // custom
			start = moment(startDate)
			end = moment(endDate)
		}
		return device && a.device === device.device && moment(a.openTime).isBetween(start, end)
	})

	if (!device && devices?.length > 0) setDevice(devices[0])

	return <div>
		<Row style={{ padding: "1rem" }}>{
			adversities.map(adversity => <AdversityItem key={adversity.name}
				adversity={adversity}
				settingsBtnAction={() => {
					if (adversity.susceptibilitySettingName) {
						setAdversitySusceptibilityModalOpen(adversity)
					} else {
						navigate(`/dss/${crop}/settings`)
					}
				}}
			/>)
		}</Row>
		<AdversitiesIntervalBar
			devices={devices}
			device={device}
			changeDevice={changeDevice}
			interval={interval}
			setInterval={setInterval}
			startDate={startDate}
			setStartDate={setStartDate}
			endDate={endDate}
			setEndDate={setEndDate}
		/>
		<Timeline
			data={filteredAlerts}
			eventTypes={adversities.map(i => ({ id: i.name, label: i.label.toUpperCase(), alertIds: i.alertIds || [] }))}
		/>

		<AdversitySusceptibilityModal
			devices={devices}
			device={device}
			changeDevice={changeDevice}
			isOpen={!!adversitySusceptibilityModalOpen}
			onClose={() => { resetSettings(); setAdversitySusceptibilityModalOpen(null) }}
			onSubmit={() => { saveSettings(); setAdversitySusceptibilityModalOpen(null) }}
			getSettingValue={getSettingValue}
			changeSetting={changeSetting}
			changeMultipleSettings={changeMultipleSettings}
			deleteSetting={deleteSetting}
			adversity={adversitySusceptibilityModalOpen}
		/>
	</div>
}
